<template>
  <div>
    <v-expand-transition>
      <div v-if="loading">
        <v-progress-linear indeterminate color="teal"></v-progress-linear>
        <br />
      </div>
    </v-expand-transition>
    <driver-nav :username="username" :user_photo="user_photo">
      <template>
        <v-toolbar-title>My Account</v-toolbar-title>
      </template>
    </driver-nav>
    <div class="profile">
      <div class="divider-section md:mr-40"></div>
      <div class="public-profile flex flex-col justify-center mx-8 md:mx-0">
        <h2 class="profile-h2">Public Profile</h2>
        <div class="public-profile-photo flex flex-row flex-wrap">
          <div class="public-profile-photo-pic">
            <v-avatar color="grey lighten-1" size="150">
              <div
                class="profile-img"
                :style="{ backgroundImage: `url('${getProfilePhoto()}')` }"
              ></div>
              <!-- <img
                  class="img-circle"
                  :src="getProfilePhoto()"
                  alt="User Avatar"
                /> -->
            </v-avatar>
          </div>

          <div>
            <div class="form-buttons">
              <!-- <v-btn
                  color="#2b282c"
                  large
                  class="profile-change-picture pt-4 pb-7"
                  >Change Picture
                  <input type="file" @change="onFileSelected" />
                </v-btn> -->
              <div class="form-buttons">
                <label class="file">
                  <input
                    type="file"
                    id="file"
                    aria-label="File browser example"
                    @change="onFileSelected"
                  />
                  <span class="file-custom">Change Picture</span>
                </label>
              </div>
            </div>
            <div class="my-2">
              <v-btn class="profile-delete-picture" @click="removePhoto">
                Delete Picture
              </v-btn>
            </div>
          </div>
        </div>
        <form
          class="body-container-form__form md:left-5"
          @submit.prevent="profileUpdate"
        >
          <div class="user-box">
            <input
              :style="[
                { borderBottom: wrongUser ? '1px solid red' : '' },
                { color: wrongUser ? 'red' : '' },
              ]"
              type="text"
              name=""
              required=""
              v-model="username"
              @blur="validateUser"
            />
            <label :style="{ color: wrongUser ? 'red' : '' }"
              >Change Username</label
            >
            <div v-if="wrongUser">
              <img class="invalidImg" src="/assets/invalid.png" alt="" />
              <p class="invalid">Invalid Username</p>
            </div>
          </div>
          <div class="user-box">
            <input type="text" name="" required="" v-model="fullname" />
            <label>Change Fullname</label>
          </div>
          <div class="user-box">
            <input type="text" name="" required="" v-model="phone" />
            <label>Change Phone number</label>
          </div>
          <div class="user-box">
            <input type="text" name="" required="" v-model="duty_start" />
            <label>Change Duty Start time</label>
          </div>
          <div class="user-box">
            <input type="text" name="" required="" v-model="duty_end" />
            <label>Change Duty End</label>
          </div>
          <div class="user-box">
            <input type="text" name="" required="" v-model="vehicle_no" />
            <label>Change Vehicle Plate no.</label>
          </div>
          <div class="user-box">
            <input type="text" name="" required="" v-model="vehicle_model" />
            <label>Change Vehicle Model</label>
          </div>
          <div class="user-box">
            <input type="password" name="" v-model="password" />
            <label>Change Password</label>
          </div>

          <button>Save</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import axios from "axios";
import DriverNav from "./DriverNav.vue";
import { mapActions } from "vuex";
export default {
  created() {
    const config = {
      headers: { Authorization: `Bearer ${this.$store.getters["auth/token"]}` },
    };
    this.username = this.$store.getters["auth/user"];
    this.role = this.$store.getters["auth/role"];

    axios
      .post(
        `${api}/users/me`,
        { username: this.username, role: this.role },
        config
      )
      .then((res) => {
        this.loading = false;
        console.log(res);
        this.fullname = res.data.data[0].fullname;
        this.duty_start = res.data.data[0].duty_start_time;
        this.duty_end = res.data.data[0].duty_end_time;
        this.vehicle_no = res.data.data[0].vehicle_no;
        this.vehicle_model = res.data.data[0].vehicle_model;

        this.phone = res.data.data[0].phone;

        if (res.data.data[0].user_photo != null)
          this.user_photo = res.data.data[0].user_photo;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  data() {
    return {
      loading: true,
      username: "",
      fullname: "",
      phone: "",
      duty_start: "",
      duty_end: "",
      vehicle_no: "",
      vehicle_model: "",
      role: "",
      user_photo: "user.png",
      password: "",
      backup: "",
      photo: null,
      dialog: false,
      empty: false,
      wrongUser: false,
      user_photo_old: null,
    };
  },
  methods: {
    ...mapActions({
      update: "auth/updateAteacher",
    }),
    // logout() {
    //   axios
    //     .get(`https://vehicle-requisition-server.onrender.com/api/users/logout`)
    //     .then((res) => {
    //       console.log(res);
    //       //this.$store.commit('change', '');
    //       sessionStorage.clear();
    //       this.$router.push("/login");
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
    validateUser() {
      this.wrongUser = false;
    },
    onFileSelected(e) {
      let file = e.target.files[0];
      let reader = new FileReader();
      let limit = 1024 * 1024 * 2;
      if (file["size"] > limit) {
        console.log("largeeeeeeeee");
      }
      reader.onloadend = () => {
        this.user_photo = reader.result;
      };
      reader.readAsDataURL(file);
      this.backup = file;
    },
    getProfilePhoto() {
      let photo =
        this.user_photo.length > 200
          ? this.user_photo
          : "https://vehicle-requisition-server.onrender.com/" +
            this.user_photo;
      return photo;
    },
    removePhoto() {
      this.user_photo = "user.png";
      this.backup = "";
    },
    profileUpdate() {
      const fd = new FormData();

      if (this.backup != "") {
        this.user_photo = this.backup;
      }

      fd.append("user_photo", this.user_photo);
      fd.append("username", this.username);
      fd.append("email", this.email);
      fd.append("fullname", this.fullname);
      fd.append("department", this.department);
      fd.append("designation", this.designation);
      fd.append("phone", this.phone);

      if (this.password != "") {
        fd.append("password", this.password);
      }
      if (typeof this.user_photo !== "string") {
        this.user_photo = `driver-${this.user_photo.lastModified}.jpeg`;
      }
      axios
        .patch(`${api}/drivers/me`, fd, {
          headers: {
            "Content-Type": `multipart/form-data;`,
            Authorization: `Bearer ${this.$store.getters["auth/token"]}`,
          },
        })
        .then(() => {
          this.update({
            username: this.username,
            user_photo: this.user_photo,
          }).then((res) => {
            console.log(res, "resss");
          });
        })
        .then(() => {
          this.$router.push("/driver-home");
        })
        .catch((err) => {
          console.log(err);
          if (err) {
            this.wrongUser = true;
          }
        });
    },
  },
  computed: {},
  components: {
    DriverNav,
  },
};
</script>

<style scoped>
.profile {
  background-color: #eeeeee;
  display: flex;
}
.profile-h2 {
  margin-top: 70px;
  margin-bottom: 25px;
  font-weight: 800;
}
.settings {
  width: 35%;
}

.settings-holder {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 60px;
}
.settings-holder p {
  margin: 10px 0px;
  border: 1px solid #2b282c54;
  padding: 10px 35px;
  border-radius: 6px;
}
.settings-holder p:hover {
  cursor: pointer;
  background-color: rgb(220, 216, 216);
}
.settings-holder h2 {
  margin-bottom: 30px;
  font-size: 32px;
}
.log-out {
  margin-top: 50px;
  /* border-style: solid; */
  padding: 12px 35px;
  border-radius: 7px;
  background-color: #ff0000ba;
  color: white;
  border: 1px groove;
  font-weight: 600;
  box-shadow: 1px 2px 6px red;
}
.divider-section {
  position: relative;
  border-right: 1px groove;
  height: 406px;
  top: 190px;
}
.invalid {
  margin: 0;
  color: red;
  position: relative;
  top: -42px;
  font-size: 12px;
  left: 20px;
}
.invalidImg {
  width: 13px;
  position: relative;
  bottom: 24px;
}
.form-buttons {
  margin-top: 28px !important;
  margin-bottom: 25px !important;
}
.profile-delete-picture {
  color: red;
  font-size: 12px;
  border: 1px solid #ff000070;
  padding-bottom: 20px !important;
  padding-top: 18px !important;
}
.public-profile-photo {
  display: flex;
}
.public-profile-photo-pic {
  margin-right: 55px;
}
.profile-img {
  width: 150px;
  background-position: inherit;
  height: 150px;
  background-size: cover;
  background-repeat: no-repeat;
}
.body-container-form__form {
  margin-top: 55px;
  position: relative;
}
.user-box {
  position: relative;
}

.user-box input {
  width: 100%;
  padding: 7px 0;
  font-size: 22px;
  color: #2b282c;
  margin-bottom: 30px;
  border: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.45);
  outline: none;
  background: transparent;
}

.user-box label {
  position: absolute;
  top: 0;
  left: 0;
  padding: 10px 0;
  font-size: 14px;
  /* color: #fff; */
  pointer-events: none;
  transition: 0.5s;
  color: #000000c4;
}

.user-box input:active,
.user-box input:focus {
  border-bottom: 1px solid #2b282c;
}

.user-box input:focus ~ label,
.user-box input:valid ~ label {
  top: -20px;
  left: 0;
  color: #2b282c;
  font-size: 12px;
  font-weight: bold;
}

.body-container-form__form button {
  width: 40%;
  height: 35px;
  background-color: #2b282c;
  color: white;
  font-size: 16px;
  margin-top: 30px;
  border-radius: 6px;
  margin-bottom: 90px;
}
.body-container-form__form button:hover {
  cursor: pointer;
  opacity: 0.9;
}
.file-custom {
  border: 1px solid;
  font-size: 12p;
  background: #2b282c;
  color: white;
  padding: 10px 17px;
  padding-bottom: 13px;

  border-radius: 6px;
}
.file-custom:hover {
  cursor: pointer;
  box-shadow: 1px 1px 3px black;
}
input[type="file"] {
  display: none;
}
</style>
